export const STAGES = [
  'START',
  'CHOOSE_IMAGE',
  'CHOOSE_COLOR',
  'CHOOSE_KEYWORD',
  'CHOOSE_MATERIAL',
];

export const MAX_IMAGE = 3;

export const MAX_COLOR = 2;

export const MAX_KEYWORD = 3;

export const MAX_MATERIAL = 2;

export const FAVORITE_TEST_RESET_CONFIRM_TITLE =
  '테스트 결과가 초기화되며, 인테리어 취향테스트 첫 화면으로 이동됩니다.\n계속 하시겠습니까?';
